/**
 * 呼吸暂停专属图
 * 浮窗 - 发生X次，持续多少
 */
export default function getEchartsOptionBarD1(xAxis_data, series_data, expansion_data) {
	let option = {
		grid: {
			x: 15,
			y: 15,
			x2: 15,
			y2: 10,
			containLabel: true
		},
		tooltip: {
			trigger: "axis",
			backgroundColor: 'rgba(255, 255, 255, 0.90)',
			borderColor: "rgba(216, 226, 248, 1)",
			borderWidth: 1,
			borderRadius: 4,
			textStyle: {
				color: "#8394B9",
				fontSize: 14
			},
			confine: true,
			formatter: function (val) {
				if (val[0].value > 0) {
					let str1 = `
					<div style='display: flex; flex-direction: column;'>
						<div style='display: flex;'>
							<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;">${val[0].name} 发生</div>
							<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 17px;">${val[0].value}</div>
							<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;">次</div>
						</div>
					`
					let str2 = '';
					for (let i = 0; i < expansion_data[val[0].dataIndex].length; i++) {
						let item = expansion_data[val[0].dataIndex][i];
						let tempStr = `
						<div style="display: flex; margin-top: 2px;">
							<div style="width: 6px; height: 6px; background: #4A7CE8; border-radius: 3px; margin-top: 6px; margin-right: 4px;"></div>
							<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;">第${i + 1}次持续</div>
							<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 17px;">${item}</div>
							<div style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;">秒</div>
						</div>
						`
						str2 += tempStr;
					}
					let str3 = `</div>`;
					return str1 + str2 + str3
				} else {
					return ''
				}
			}
		},
		color: ["#1890FF"],
		xAxis: [
			{
				type: "category",
				axisTick: {
					//y轴刻度线
					show: false,
				},
				axisLabel: {
					textStyle: {
						color: "#A5A9BC", //坐标的字体颜色
						fontSize: 10
					},
					textAlign: 'right'
				},
				axisLine: {
					lineStyle: {
						color: "#A5A9BC",
					},
				},
				data: xAxis_data
			},
		],
		yAxis: [
			{
				type: "value",
				// max: 1,
				minInterval: 1,

				axisLine: {
					show: false,
				},
				axisTick: {
					//y轴刻度线
					show: false,
				},
				axisLabel: {
					fontSize: 10,
					formatter: function (val) {
						if (val == 0) {
							return null
						}
						return val + '次';
					},
					textStyle: {
						color: "#A5A9BC", //坐标的字体颜色
						fontSize: 10
					},
					show: true,
				},
			},
		],
		series: [
			{
				name: "呼吸暂停",
				type: "bar",
				stack: "总量",
				xAxisIndex: 0,
				data: series_data,
				itemStyle: {
					normal: {
						color: 'rgba(74, 124, 232, 1)'
					},
				}
			},
		],
	};
	return option;
}